import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Link, 
  IconButton,
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LDLOGO from '../assets/liderdistbrief.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const contactInfo = {
    email: 'contacto@liderdist.com',
    phone: '1552218205',
    whatsapp: 'https://wa.me/5491552218205',
    instagram: 'https://www.instagram.com/liderdist.arg',
    x: 'https://www.x.com/liderdist_arg',
    linkedin: 'https://www.linkedin.com/company/liderdist-com'
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e0e0e0',
        mt: 'auto',
        py: 4
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and Description */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
              <img 
                src={LDLOGO} 
                alt="Liderdist Logo" 
                style={{ 
                  height: '60px',
                  marginBottom: '1rem'
                }} 
              />
              <Typography 
                variant="body2" 
                color="text.secondary"
                align={isMobile ? 'center' : 'left'}
                sx={{ maxWidth: '300px' }}
              >
                Conectando distribuidores y comercios en toda Argentina. 
                La plataforma líder en comercio mayorista.
              </Typography>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom align={isMobile ? 'center' : 'left'}>
              Enlaces Útiles
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
              <Link component={RouterLink} to="/about" color="text.secondary" sx={{ mb: 1 }}>
                Sobre Nosotros
              </Link>
              <Link component={RouterLink} to="/contact" color="text.secondary" sx={{ mb: 1 }}>
                Contacto
              </Link>
              <Link component={RouterLink} to="/pricing" color="text.secondary" sx={{ mb: 1 }}>
                Planes y Precios
              </Link>
              <Link component={RouterLink} to="/terms-and-services" color="text.secondary" sx={{ mb: 1 }}>
                Términos y Condiciones
              </Link>
              <Link component={RouterLink} to="/privacy-policy" color="text.secondary">
                Política de Privacidad
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom align={isMobile ? 'center' : 'left'}>
              Contacto
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
                <Link href={`mailto:${contactInfo.email}`} color="text.secondary">
                  {contactInfo.email}
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <WhatsAppIcon sx={{ mr: 1, color: 'text.secondary' }} />
                <Link href={contactInfo.whatsapp} color="text.secondary" target="_blank">
                  +54 {contactInfo.phone}
                </Link>
              </Box>
            </Box>

            {/* Social Media Icons */}
            <Box sx={{ 
              mt: 2, 
              display: 'flex', 
              gap: 1,
              justifyContent: { xs: 'center', md: 'flex-start' }
            }}>
              <IconButton href={contactInfo.instagram} target="_blank" size="small">
                <InstagramIcon />
              </IconButton>
              <IconButton href={contactInfo.x} target="_blank" size="small">
                <XIcon />
              </IconButton>
              <IconButton href={contactInfo.linkedin} target="_blank" size="small">
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Copyright */}
        <Typography 
          variant="body2" 
          color="text.secondary" 
          align="center"
        >
          © {new Date().getFullYear()} Liderdist. Todos los derechos reservados.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 